import { LOCALES, type Market } from '@backmarket/http-api'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { MARKETS } from '../../config'

/** Get all available markets */
export function getMarkets(
  enableEsUsContent: boolean,
): Record<MarketCountryCode, Market> {
  const markets = { ...MARKETS }

  if (enableEsUsContent) {
    markets[MarketCountryCode.US] = {
      ...markets[MarketCountryCode.US],
      locales: [...markets[MarketCountryCode.US].locales, LOCALES.es_US],
    }
  }

  return markets
}
